
import React from 'react';
import * as Styled from './styles.module';
import { format } from 'date-fns';

interface IChatDateItemProps {
    date : string;
}

type Props =  IChatDateItemProps;

export class ChatDateItem extends React.Component<Props> {

  state : any = {}

  render() {
    
    return (
        <Styled.DateItem>
            <Styled.DateItemShadow>
                {format(new Date(this.props.date), 'MM/dd/yyyy')}
            </Styled.DateItemShadow>
        </Styled.DateItem>
    );
  }
}
